module.exports = __webpack_public_path__ + "img/trophy.9dc1d2a2.svg";